module.exports = __webpack_public_path__ + "partylineManage/img/kioskPicture.5bc5a3a3.png";